import { styled } from "@mui/material";
import { Modal } from "kvweb-ui";
import React from "react";

const CustomModal = styled(Modal)({});

interface IProps {
  open: boolean;
  handCancel?: VoidFunction;
  handConfirm?: VoidFunction;
}
export default function PublishPreviewWebsiteModal({
  open,
  handCancel,
  handConfirm,
}: IProps) {
  return (
    <Modal
      open={open}
      onClose={handCancel}
      isDefault
      textTittle={"Thông báo"}
      textContent={"Bạn có muốn ngừng xuất bản website ngay bây giờ?"}
      textConfirm={"Huỷ"}
      textCancel={"Ngừng xuất bản"}
      buttonConfirmProps={{
        onClick: handCancel,
        btnType: "outlined",
        sx: {
          width: "150px",
        },
      }}
      buttonCancelProps={{
        onClick: handConfirm,
        btnType: "solid",
        btnColor: "red",
        sx: {
          width: "150px",
        },
      }}
    ></Modal>
  );
}
